import { StageResultDetail } from "../playGroundTypes";

interface StageDetailProps {
  detail: StageResultDetail;
}

const StageDetail = ({ detail }: StageDetailProps) => {
  return (
    <div className="border-gray-15 border-l-2 px-4 py-3">
      <div className="mb-1 text-sm font-medium text-gray-700">
        Action Triggered:{" "}
        <span className="font-semibold text-gray-900">
          {detail.actionTriggered}
        </span>
      </div>
      <div className="text-sm text-gray-600">{detail.description}</div>
    </div>
  );
};

export default StageDetail;
